/**
 * What a node calls itself, cut to fit a table.
 *
 * A claimed name is whatever the node put in its registration — a fully
 * qualified hostname, a path, a sentence somebody pasted. One long one stretches
 * every other column of the table it is in, so it is cut here rather than by the
 * browser: an ellipsis in the middle of a layout is a column that moved, while
 * an ellipsis in the text is a name that is too long.
 *
 * The full value still reaches the person — the cell carries it as its title —
 * so nothing is lost, only folded.
 */

/** Past this, a name is folded. */
export const NAME_LIMIT = 40;

/** What is kept when it is, with the ellipsis after it — 38 characters shown. */
const KEPT = 37;

export function shortName(name: string): string {
  return name.length > NAME_LIMIT ? `${name.slice(0, KEPT)}…` : name;
}
